import { render, staticRenderFns } from "./statusHistory.vue?vue&type=template&id=18bc1cc1&scoped=true"
import script from "./statusHistory.vue?vue&type=script&lang=js"
export * from "./statusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc1cc1",
  null
  
)

export default component.exports